// @df/ui - Shared theme configuration for DataFre8 applications
import { createTheme } from '@mui/material/styles';
// DataFre8 brand colors
export const colors = {
    primary: {
        main: '#1976d2',
        light: '#42a5f5',
        dark: '#1565c0',
        contrastText: '#ffffff'
    },
    secondary: {
        main: '#dc004e',
        light: '#ff5983',
        dark: '#9a0036',
        contrastText: '#ffffff'
    },
    background: {
        default: '#f5f5f5',
        paper: '#ffffff'
    },
    text: {
        primary: '#212121',
        secondary: '#757575'
    },
    error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f'
    },
    warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00'
    },
    info: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2'
    },
    success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c'
    }
};
// Typography configuration
export const typography = {
    fontFamily: [
        'Kalameh',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif'
    ].join(','),
    h1: {
        fontSize: '2.5rem',
        fontWeight: 600,
        lineHeight: 1.2
    },
    h2: {
        fontSize: '2rem',
        fontWeight: 600,
        lineHeight: 1.3
    },
    h3: {
        fontSize: '1.75rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    h4: {
        fontSize: '1.5rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    h5: {
        fontSize: '1.25rem',
        fontWeight: 600,
        lineHeight: 1.5
    },
    h6: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5
    },
    body1: {
        fontSize: '1rem',
        lineHeight: 1.6
    },
    body2: {
        fontSize: '0.875rem',
        lineHeight: 1.6
    }
};
// Spacing configuration
export const spacing = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48
};
// Breakpoints configuration
export const breakpoints = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
};
// Create Material-UI theme
export const theme = createTheme({
    palette: colors,
    typography,
    spacing: 8, // Base spacing unit
    breakpoints: {
        values: breakpoints
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    fontWeight: 500
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                    }
                }
            }
        }
    }
});
// Export theme as default
export default theme;
